import { FC } from 'react'
import appConfig from '#/src/appConfig'
import { MenuStandardSlideOutMobileMenuFooter } from 'storefront-modules/layout/Menu/MenuStandard'

interface IMobileMenuSlideOutFooterProps {}

const MobileMenuSlideOutFooter: FC<IMobileMenuSlideOutFooterProps> = () => {
  return <MenuStandardSlideOutMobileMenuFooter panelItems={appConfig.topNavPanel?.items} />
}

export default MobileMenuSlideOutFooter
